import React from 'react'
import { Col, Row } from 'antd'
import styled from 'styled-components'

import maleIcon from 'src/assets/icons/male.svg'
import femaleIcon from 'src/assets/icons/female.svg'
import { USER_GENDER } from 'src/constants/user'

interface Props {
  value?: string
  onChange: (value: string) => void
}

const GenderSelection = ({ value, onChange }: Props) => {
  return (
    <Row className="justify-content-between">
      {[
        { id: USER_GENDER.MALE, label: '男性', icon: maleIcon, colClass: '' },
        {
          id: USER_GENDER.FEMALE,
          label: '女性',
          icon: femaleIcon,
          colClass: 'ml-20',
        },
      ].map((item) => (
        <Col xs={11} className={item.colClass} key={item.id}>
          <GenderItem
            onClick={() => onChange(String(item.id))}
            className={value === String(item.id) ? 'selected' : ''}
          >
            <GenderImg src={item.icon} alt={item.label} />
            <GenderHint>{item.label}</GenderHint>
          </GenderItem>
        </Col>
      ))}
    </Row>
  )
}

const GenderItem = styled.div`
  display: flex;
  border: none;
  padding: 10px;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid var(--color-pampas);

  &.selected {
    border-color: #980;
    background-color: #f1efe7;
    border: unset;
  }
`
const GenderHint = styled.p`
  height: 40px;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 13px;
  margin-left: 10px;
`
const GenderImg = styled.img`
  width: 40px;
  height: 40px;
`

export default GenderSelection
